import { BOOK } from "@/data/book";

export const Footer = () => (
  <footer data-testid="footer-section" className="bg-[#201c19] text-stone-400">
    <div className="max-w-6xl mx-auto px-6 py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <h2
            data-testid="footer-title"
            className="font-display text-3xl sm:text-4xl text-[#f5f2ea] font-light leading-tight"
          >
            Ascent of the <span className="italic text-[#8fc0bb]">Hummingbird</span>
          </h2>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-stone-400/90">
            A contemplative poetry collection by {BOOK.author} — a journey from pain to presence.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-4">Explore</p>
          <ul data-testid="footer-links" className="space-y-3 text-sm">
            <li><a href="#about" className="hover:text-[#f5f2ea] transition-colors">The Book</a></li>
            <li><a href="#poems" className="hover:text-[#f5f2ea] transition-colors">Sample Poems</a></li>
            <li><a href="#themes" className="hover:text-[#f5f2ea] transition-colors">Themes</a></li>
            <li><a href="#author" className="hover:text-[#f5f2ea] transition-colors">The Author</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-4">Connect</p>
          <ul className="space-y-3 text-sm">
            <li><span className="text-stone-500">Readings &amp; events — coming soon</span></li>
            <li><span className="text-stone-500">Newsletter — coming soon</span></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p data-testid="footer-copyright" className="text-xs text-stone-500">
          © {new Date().getFullYear()} {BOOK.author}. All rights reserved.
        </p>
        <p data-testid="footer-amazon-disclaimer" className="text-xs text-stone-600">
          Amazon and the Amazon logo are trademarks of Amazon.com, Inc.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
